import http from "../../../../services/http-common";

class financialService {
  // eslint-disable-next-line class-methods-use-this
  async billingClose() {
    try {
      return http.post(`/customer/financial/close/0/0/0`);
    } catch (error) {
      console.log(error);
    }
  }

  async rollbackClose(idBilling: any) {
    try {
      return http.delete(`/billing/financial/rollback/${idBilling}`);
    } catch (error) {
      console.log(error);
    }
  }

  async getOpenOrdersTotals(forceRefresh = false) {
    try {
      return http.get("/billing/financial/open-orders-totals", {
        params: forceRefresh ? { refresh: "1" } : undefined,
      });
    } catch (error) {
      console.log(error);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  getAll(offset: string, limit: string, params: any) {
    return http.get(`billing/financial/close/${offset}/${limit}`, {
      params: params,
    });
  }

  getAllOrders(idBilling: string) {
    return http.get(`billing/financial/report/${idBilling}`);
  }

  async getFinancialCustomers(
    idBilling: string,
    branch?: string,
    orderCode?: string,
  ) {
    return http.get(`/billing/financial/customers/${idBilling}`, {
      params: { branch, orderCode },
    });
  }

  async getFinancialDetailsByCustomer(
    idBilling: string,
    idCustomer: string,
    orderCode?: string,
  ) {
    return http.get(`/billing/financial/details/${idBilling}/${idCustomer}`, {
      params: { orderCode },
    });
  }

  getRankingAR(startDate: number, endDate: number, branch: string) {
    return http.get("/order/report/ranking-ar", {
      params: { startDate, endDate, branch },
    });
  }
}

export default new financialService();
